import { Box, Card, CardActionArea, Stack, Typography } from "@mui/material";
import termsOfUse from "../../../assets/termsOfUse.pdf";
import { usePageTitle } from "../../logic";

const legalLinks = [
  {
    id: "terms",
    title: "Terms of Use",
    href: termsOfUse,
  },
  {
    id: "privacy",
    title: "Privacy Policy",
    href: "https://www.closesimple.com/privacy-policy",
  },
];


export function LegalPage() {
  usePageTitle("Terms and Privacy");

  return (
    <Box
      component="main"
      sx={{
        p: 2,
        maxWidth: 720,
        mx: "auto",
        mt: '70px' 
      }}
    >
      <Typography variant="h4" sx={{ fontWeight: 500 }}>
         Terms and Privacy 
      </Typography>

      <Stack spacing={2.5} sx={{ mt: 4 }}>
        {legalLinks.map((link) => (
          <Card
            key={link.id}
            elevation={0}
            sx={{
              borderRadius: 3,
              border: "1px solid",
              borderColor: "divider",
            }}
          >
            <CardActionArea
              component="a"
              href={link.href}
              target="_blank"
              rel="noopener noreferrer"
              sx={{ p: { xs: 3, sm: 4 }, "&:hover": { bgcolor: "primary.dark", color: 'secondary.main' } }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: 2,
                }}
              >
                <Typography variant="h6" sx={{ fontWeight: 500 }}>
                  {link.title}
                </Typography>
                <Typography variant="body2" sx={{ fontSize: 15 }} color="primary.main">
                    Open
                </Typography>
              </Box>
            </CardActionArea>
          </Card>
        ))}
      </Stack>
    </Box>
  );
}
